import { Injectable, InjectionToken, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Languages } from 'src/app/route-translate.strategy';

export const LANGUAGES = new InjectionToken<Languages[]>('LANGUAGES');
export const DEFAULT_LANGUAGE = new InjectionToken<Languages>('DEFAULT_LANGUAGE');

export function i18nInitializer(i18nService: I18nService): () => Promise<boolean> {
  return (): Promise<boolean> => {
    return new Promise((resolve, reject) => {
      try {
        i18nService.init();
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  };
}

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  translate = inject(TranslateService);
  readonly languages = inject<Languages[]>(LANGUAGES);
  readonly defaultLanguage = inject<Languages>(DEFAULT_LANGUAGE);

  language: string;
  constructor() {
    this.language = this.defaultLanguage;
  }

  init(): void {
    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang(this.defaultLanguage);
    this.language = this.getLanguage();
    this.translate.use(this.language).subscribe();
  }

  setLanguage(lang: string): void {
    this.language = lang;
  }

  getLanguage(): string {
    // Check url language
    const urlLang = this.getUrlLanguage();
    if (urlLang) {
      return urlLang;
    }

    // check browserLanguage
    const browserLang = this.getBrowserLanguage();
    if (browserLang) {
      return browserLang;
    }

    // Return default
    return this.defaultLanguage;
  }

  getUrlLanguage(): string | undefined {
    // Check language at the beginning of the base path.
    const urlLang = window.location.pathname.split('/')[1];
    if (this.languages.find((el) => el === urlLang)) {
      return urlLang;
    }

    return undefined;
  }

  private getBrowserLanguage(): string | undefined {
    const browserLang = this.translate.getBrowserLang();
    if (this.languages.find((el) => el === browserLang)) {
      return browserLang;
    }
    return undefined;
  }
}
